"use client";
import {
  AppBar,
  Toolbar,
  Box,
  Typography,
  Dialog,
  TextField,
  darken,
  Container,
  TablePagination,
} from "@mui/material";
import { Search, Close, Menu } from "@mui/icons-material";
import { IconButton, Link } from "gatsby-theme-material-ui";
import React from "react";
import AppDrawer from "./AppDrawer";
import { graphql, useStaticQuery } from "gatsby";
import { TextCard } from "./TextCard";
import { MenuItemsList } from "./MenuItemsList";
import { useAllMenuItems } from "../helpers/useAllMenuItems";

export const Logo = ({ domain }) => (
  <Typography
    variant="h3"
    noWrap
    sx={{
      lineHeight: 0.75,
      display:
        typeof window !== `undefined` &&
        (domain === "http://localhost:8000" || domain === "https://vestimak.mk")
          ? "block"
          : "none",
    }}
  >
    <Box
      component="span"
      sx={{
        backgroundImage: (theme) =>
          `linear-gradient(0deg, ${darken(
            theme.palette.primary.main,
            0.7
          )}, ${darken(theme.palette.primary.main, 0.3)})`,
        backgroundSize: "100%",
        backgroundRepeat: "repeat",
        backgroundClip: "text",
        WebkitBackgroundClip: "text",
        WebkitTextFillColor: "transparent",
        fontWeight: 900,
      }}
    >
      {"ВЕСТИ".toUpperCase()}
    </Box>
    <span
      style={{
        fontWeight: 900,
      }}
    >
      МАК.MK
    </span>
  </Typography>
);

export const Logo2 = ({ domain }) => (
  <Typography
    variant="h3"
    noWrap
    sx={{
      display:
        typeof window !== `undefined` &&
        (domain === "http://localhost:8001" || domain === "https://vestimk.mk")
          ? "block"
          : "none",
    }}
  >
    <Box
      component="span"
      sx={{
        backgroundImage: (theme) =>
          `linear-gradient(0deg, ${darken(
            theme.palette.primary.main,
            0.7
          )}, ${darken(theme.palette.primary.main, 0.3)})`,
        backgroundSize: "100%",
        backgroundRepeat: "repeat",
        backgroundClip: "text",
        WebkitBackgroundClip: "text",
        WebkitTextFillColor: "transparent",
        fontWeight: 900,
      }}
    >
      {"ВЕСТИМК.MK".toUpperCase()}
    </Box>
    {/* <span
      style={{
        fontWeight: 900,
      }}
    >
      МК.MK
    </span> */}
  </Typography>
);

const Logo3 = ({ domain }) => {
  return (
    <Typography
      variant="h3"
      noWrap
      sx={{
        display:
          typeof window !== `undefined` &&
          (domain === "http://localhost:8002" || domain === "https://utre.mk")
            ? "block"
            : "none",
      }}
    >
      <Box
        component="span"
        sx={{
          // backgroundImage: (theme) =>
          //   `linear-gradient(0deg, ${darken(
          //     theme.palette.primary.main,
          //     0.7
          //   )}, ${darken(theme.palette.primary.main, 0.3)})`,
          // backgroundSize: "100%",
          // backgroundRepeat: "repeat",
          // backgroundClip: "text",
          // WebkitBackgroundClip: "text",
          // WebkitTextFillColor: "transparent",
          color: (theme) => darken(theme.palette.primary.main, 0.45),
          fontWeight: 900,
        }}
      >
        {"УТРЕ.MK".toUpperCase()}
      </Box>
      {/* <span
      style={{
        fontWeight: 900,
      }}
    >
      МК.MK
    </span> */}
    </Typography>
  );
};

const Logo4 = ({ domain }) => {
  return (
    <Typography
      variant="h3"
      noWrap
      sx={{
        display:
          typeof window !== `undefined` &&
          (domain === "http://localhost:8003" || domain === "https://24mk.mk")
            ? "block"
            : "none",
      }}
    >
      <Box
        component="span"
        sx={{
          // backgroundImage: (theme) =>
          //   `linear-gradient(0deg, ${darken(
          //     theme.palette.primary.main,
          //     0.7
          //   )}, ${darken(theme.palette.primary.main, 0.3)})`,
          // backgroundSize: "100%",
          // backgroundRepeat: "repeat",
          // backgroundClip: "text",
          // WebkitBackgroundClip: "text",
          // WebkitTextFillColor: "transparent",
          color: (theme) => theme.palette.primary.main,
          fontWeight: 900,
        }}
      >
        {"24".toUpperCase()}
        <Box component={"span"} sx={{ color: "secondary.main" }}>
          MK
        </Box>
      </Box>
      {/* <span
      style={{
        fontWeight: 900,
      }}
    >
      МК.MK
    </span> */}
    </Typography>
  );
};

const Logo5 = ({ domain }) => {
  return (
    <Typography
      variant="h3"
      noWrap
      sx={{
        display:
          typeof window !== `undefined` &&
          (domain === "http://localhost:8004" || domain === "https://mk24.mk")
            ? "block"
            : "none",
      }}
    >
      <Box
        component="span"
        sx={{
          // backgroundImage: (theme) =>
          //   `linear-gradient(0deg, ${darken(
          //     theme.palette.primary.main,
          //     0.7
          //   )}, ${darken(theme.palette.primary.main, 0.3)})`,
          // backgroundSize: "100%",
          // backgroundRepeat: "repeat",
          // backgroundClip: "text",
          // WebkitBackgroundClip: "text",
          // WebkitTextFillColor: "transparent",
          //   color: (theme) => theme.palette.primary.main,
          fontWeight: 900,
        }}
      >
        {"MK24".toUpperCase()}
      </Box>
      {/* <span
      style={{
        fontWeight: 900,
      }}
    >
      МК.MK
    </span> */}
    </Typography>
  );
};

const NavigationBar = ({ rightIcon }) => {
  const [open, setOpen] = React.useState(false);
  const [searchOpen, setSearchOpen] = React.useState(false);
  const [searchKeyword, setSearchKeyword] = React.useState("");
  const [page, setPage] = React.useState(0);
  const [rowsPerPage, setRowsPerPage] = React.useState(100);

  const handleChangePage = (
    event: React.MouseEvent<HTMLButtonElement> | null,
    newPage: number
  ) => {
    setPage(newPage);
  };

  const handleChangeRowsPerPage = (
    event: React.ChangeEvent<HTMLInputElement | HTMLTextAreaElement>
  ) => {
    setRowsPerPage(parseInt(event.target.value, 10));
    setPage(0);
  };
  const { allMenuItems } = useAllMenuItems();
  // const { allMarkdownRemark } = useStaticQuery(graphql`
  //   query {
  //     allMarkdownRemark {
  //       nodes {
  //         to: gatsbyPath(
  //           filePath: "/{MarkdownRemark.frontmatter__category}/{MarkdownRemark.frontmatter__title}"
  //         )
  //         frontmatter {
  //           title
  //           category
  //           date(formatString: "DD MMMM YYYY", locale: "mk-MK")
  //         }
  //         excerpt
  //       }
  //     }
  //     allMenuItems: allMarkdownRemark {
  //       group(field: { frontmatter: { category: SELECT } }, limit: 1) {
  //         field
  //         nodes {
  //           frontmatter {
  //             category
  //           }
  //           gatsbyPath(filePath: "/{MarkdownRemark.frontmatter__category}/")
  //         }
  //       }
  //     }
  //   }
  // `);

  const changeHandler = (event) => {
    setSearchKeyword(event.target.value);
  };
  const [domain, setDomain] = React.useState(null);
  React.useEffect(() => {
    setDomain(window?.location.origin);
  }, []);
  return (
    <>
      <AppBar color="inherit" variant="outlined">
        <Toolbar component={Container} maxWidth="lg">
          <Box mr={1} sx={{ display: { xs: "block", lg: "none" } }}>
            <IconButton onClick={() => setOpen(true)}>
              <Menu />
            </IconButton>
          </Box>
          <Link to="/" color="textPrimary" style={{ textDecoration: "none" }}>
            <Logo domain={domain} />
            <Logo2 domain={domain} />
            <Logo3 domain={domain} />
            <Logo4 domain={domain} />
            <Logo5 domain={domain} />
            {/* <span>Вистината пред се</span> */}
          </Link>
          <Box flex={1}></Box>
          <MenuItemsList sx={{ display: { xs: "none", lg: "block" } }} />
          {/* <IconButton onClick={() => setSearchOpen(true)}>
            <Search />
          </IconButton> */}
          {rightIcon}
        </Toolbar>
      </AppBar>
      <Toolbar />
      {/* <Container
        sx={{
          mt: 1,
          mb: 1,
          display: { xs: "flex", lg: "none" },
          overflow: "auto",
        }}
      >
        <Box flex={1} />
        <MenuItemsList
          sx={{
            display: { xs: "block", lg: "none" },
            // justifyContent: { xs: "initial", sm: "space-around" },
          }}
        />
      </Container> */}
      {/* <Dialog open={searchOpen} fullScreen>
        <Toolbar>
          <IconButton color="default" onClick={() => setSearchOpen(false)}>
            <Close />
          </IconButton>
        </Toolbar>
        <Box m={2}>
          <TextField
            fullWidth
            placeholder="Барај вести"
            value={searchKeyword}
            onChange={changeHandler}
          />
          <Container>
            <TablePagination
              component="div"
              count={allMarkdownRemark.nodes.length}
              page={page}
              onPageChange={handleChangePage}
              rowsPerPage={rowsPerPage}
              onRowsPerPageChange={handleChangeRowsPerPage}
              labelRowsPerPage="Вести по страница:"
              labelDisplayedRows={({ from, to, count }) =>
                `${from}–${to} од ${count !== -1 ? count : `повеќе од ${to}`}`
              }
              getItemAriaLabel={(type) => {
                return `Одете на ${type} страница`;
              }}
            />
            {allMarkdownRemark.nodes
              .filter((i) =>
                i.frontmatter.title
                  .toLowerCase()
                  .includes(searchKeyword.toLowerCase())
              )
              .slice(page * rowsPerPage, (page + 1) * rowsPerPage)
              .map((i) => (
                <TextCard
                  key={i.id}
                  {...i}
                  title={i.frontmatter.title}
                  date={i.frontmatter.date}
                  category={i.frontmatter.category}
                />
              ))}
          </Container>
        </Box>
      </Dialog> */}
      <AppDrawer open={open} setOpen={setOpen} navigationItems={allMenuItems} />
    </>
  );
};
export default NavigationBar;
